import * as React from 'react';

const stateToggle = (setState, useCallback = true) => {
  const toggleFunc = (selectedItem) => setState((previous) => (previous || []).toggle(selectedItem));
  return useCallback ? React.useCallback(toggleFunc, []) : toggleFunc;
};

export default stateToggle;
